// extracted by mini-css-extract-plugin
export var buttons = "_9j-0";
export var buttonsActive = "_9j-h";
export var cancelConfirm = "_9j-1";
export var closeButton = "_9j-2";
export var column = "_9j-3";
export var container = "_9j-4";
export var detailHeader = "_9j-6";
export var detailTitle = "_9j-7";
export var detailsContent = "_9j-5";
export var header = "_9j-8";
export var headerWithClose = "_9j-9";
export var icon = "_9j-a";
export var infoIcon = "_9j-c";
export var informationContainer = "_9j-b";
export var sideDrawer = "_9j-d";
export var sideDrawerOpen = "_9j-e";
export var stickyFooter = "_9j-f";
export var typeOption = "_9j-g";